module.exports = __webpack_public_path__ + "f3612dde5a1af12d1fb827b23bdde449.png";